import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { ReportListResponseModel, ReportModel } from '../../models/report.model';
import { baseQuery } from './base.query';

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: baseQuery,
  tagTypes: ['Report'],
  endpoints: (builder) => ({
    getReportList: builder.query<ReportListResponseModel[], string>({
      query: () => ({
        url: `${API_PREFIX.NEXTGEN}${API.REPORT}`,
      }),
      providesTags: ['Report'],
    }),
    createReport: builder.mutation<number, ReportModel>({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.REPORT}`,
        method: 'POST',
        body: JSON.stringify(args),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Report'],
    }),
    updateReport: builder.mutation<unknown, ReportModel>({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.REPORT}/${args.id}`,
        method: 'PUT',
        body: JSON.stringify(args),
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Report'],
    }),
    getViewReport: builder.query<unknown, string>({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.REPORT}/${args}`,
      }),
    }),
    deleteReport: builder.mutation<unknown, string>({
      query: (args) => ({
        url: `${API_PREFIX.NEXTGEN}${API.REPORT}/${args}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Report'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetReportListQuery,
  useCreateReportMutation,
  useGetViewReportQuery,
  useDeleteReportMutation,
  useUpdateReportMutation,
} = reportsApi;
